// extracted by mini-css-extract-plugin
module.exports = {"hover-trigger":"QuestionMarkTooltip_hover-trigger__1940s","hover-target":"QuestionMarkTooltip_hover-target__1opFE","item-bubble":"QuestionMarkTooltip_item-bubble__6R9EP"};